import { Action } from "./action";
import { Actions } from "./actions";

interface Five9CallVariablesModel {
  sourceId: string;
  subjectId: string;
}

const initial: Five9CallVariablesModel = {
  sourceId: "",
  subjectId: "",
};

export const five9CallVariables = (context: any) => {
  const { log } = context;
  return (
    state: Five9CallVariablesModel = initial,
    action: Action<Actions>
  ) => {
    let updated = state;
    const { type, payload } = action;
    switch (type) {
      case Actions.SETCALLVARIABLES:
        updated = { ...updated, ...payload };
        break;
       default:
          // Handle unexpected action types here
        break;
    }
    return updated;
  };
};
